export default __webpack_public_path__ + "static/media/logoDark.2fed347e.svg";